import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class WimdModalsService {

  constructor(
    private http: HttpClient,
  ) {

  }

  getMedia(projectId, mediaType: 'pdf' | 'image' | 'video', passageId) {
    return this.http.get(`projects/${projectId}/passages/${passageId}/download?media_type=${mediaType}`);
  }

  getPDF(projectId, passageId) {
    return this.http.get(`projects/${projectId}/passages/${passageId}/download?media_type=pdf`, {responseType: 'blob'});
  }

}
